

// @ts-nocheck

import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            customModel: false
        }
    },
    watch: {
        customModel(v: boolean): void {
            this.$emit('update', v)
        }
    },
    created(): void {
        if (!this.fieldAddress) {
            this.customModel = this.customModelInitValue
        } 
    },
    props: {
        labelExtra: {
            type: [Boolean, String],
            default: false
        },
        ifNegative: {
            type: [String, Boolean],
            default: false
        },
        label: {
            type: [Boolean, String],
            default: false
        },
        fieldAddress: {
            type: [Array, Boolean],
            default: false
        },
        text: String,
        textTip: {
            type: [Boolean, String],
            default: false
        },
        customModelInitValue: {
            type: [Boolean],
            default: null
        },
        subText: {
            type: [Boolean, String],
            default: false
        }
    },
      computed: {
        modelLocation: {
            get(): boolean {
                // @ts-ignore
                if (this.fieldAddress) {  
                    // @ts-ignore                  
                    return this.field
                } else { 
                    // @ts-ignore
                    return this.customModel 
                }
            },
            set(v: boolean): void { 
                // @ts-ignore
                if (this.fieldAddress) {
                    // @ts-ignore
                    this.field = v
                } else { 
                    // @ts-ignore
                    this.customModel = v
                }

            }
        },
        field: {
                get: function() {     
                    // @ts-ignore
                    return this.$store.getters['survey/stepField'](this.fieldAddress)
                },
                set: function(v) {
                    // @ts-ignore 
                    this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                        fieldAddress: this.fieldAddress,
                        val: v
                    })
                }            
            }
    }
})

